import slugifyLib from 'slugify';

export const slugify = (text: string) => {
    return slugifyLib(text, {
        remove: undefined,
        lower: true,
        replacement: '-'
    });
};
